import { useEffect, useState } from "react";
import { useBlocker } from "react-router-dom";
import { useLogout } from "../../../utils/hooks/useLogout";
import ConfirmCloseModal from "../../../components/ConfirmCloseModal/ConfirmCloseModal";

interface NavigationWarningModalProps {
  hasUnsavedChanges: boolean;
}

const NavigationWarningModal = ({
  hasUnsavedChanges,
}: NavigationWarningModalProps) => {
  const [showModal, setShowModal] = useState(false);

  const { completeLogout, cancelLogout, isLoggingOut } = useLogout();

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      (hasUnsavedChanges || isLoggingOut) &&
      currentLocation.pathname !== nextLocation.pathname
  );

  useEffect(() => {
    if (blocker.state === "blocked") {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [blocker]);

  const handleStay = () => {
    if (blocker.state === "blocked") {
      blocker.reset();
      setShowModal(false);
      if (isLoggingOut) {
        cancelLogout();
      }
    }
  };

  const handleLeave = async () => {
    if (blocker.state === "blocked") {
      if (isLoggingOut) {
        await completeLogout();
      }
      blocker.proceed();
      setShowModal(false);
    }
  };

  return (
    <ConfirmCloseModal
      modalOpened={showModal}
      closeModal={handleLeave}
      handleSelectNo={handleStay}
      customText={{
        text: "You have unsaved changes. Are you sure you want to leave?",
        title: "Unsaved Changes",
        buttonLabels: {
          left: "Stay",
          right: "Leave",
        },
      }}
    />
  );
};

export default NavigationWarningModal;
